import { render, staticRenderFns } from "./comment-user-icon.vue?vue&type=template&id=5358d00d&lang=pug"
import script from "./comment-user-icon.vue?vue&type=script&lang=js"
export * from "./comment-user-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports